import { Switch, TextField } from '@chronosphereio/chrono-ui';
import { OptionsEditorControl, OptionsEditorGroup, SettingsAutocomplete } from '@/plugin-editor-components/components';
import { HeatmapColorOptions, HeatmapColorScale } from '../../../../core';

const SCALE_OPTIONS: Array<{ id: HeatmapColorScale; label: string; group: string }> = [
  { id: 'turbo', label: 'Turbo', group: 'Rainbow' },
  { id: 'inferno', label: 'Inferno', group: 'Perceptually Uniform' },
  { id: 'viridis', label: 'Viridis', group: 'Perceptually Uniform' },
  { id: 'greenBlue', label: 'Green->Blue', group: 'Sequential' },
  { id: 'orangeRed', label: 'Orange->Red', group: 'Sequential' },
  { id: 'cividis', label: 'Cividis', group: 'Vision Deficiency' },
  { id: 'greys', label: 'Greys', group: 'Monochromatic' },
  { id: 'blues', label: 'Blues', group: 'Monochromatic' },
  { id: 'greens', label: 'Greens', group: 'Monochromatic' },
  { id: 'oranges', label: 'Oranges', group: 'Monochromatic' },
  { id: 'reds', label: 'Reds', group: 'Monochromatic' },
];

export interface ColorOptionsEditorProps {
  value: HeatmapColorOptions;
  onChange: (color: HeatmapColorOptions) => void;
}

export function ColorOptionsEditor({ value, onChange }: ColorOptionsEditorProps) {
  return (
    <OptionsEditorGroup title="Visual">
      <OptionsEditorControl
        label="Color palette"
        control={
          <SettingsAutocomplete
            value={SCALE_OPTIONS.find((o) => o.id === value.scale) ?? SCALE_OPTIONS[0]}
            options={SCALE_OPTIONS}
            onChange={(_, newValue) => onChange({ ...value, scale: newValue.id })}
            groupBy={(option) => option.group}
            disableClearable
          />
        }
      />
      <OptionsEditorControl
        label="Invert palette"
        control={
          <Switch
            checked={value.invertScale ?? false}
            onChange={(e) => onChange({ ...value, invertScale: e.target.checked })}
          />
        }
      />
      <OptionsEditorControl
        label="Min value"
        description="Minimum data value mapped to the color palette"
        control={
          <TextField
            fullWidth
            type="number"
            value={value.min ?? ''}
            onChange={(e) => onChange({ ...value, min: e.target.value ? Number(e.target.value) : undefined })}
            placeholder="Default"
          />
        }
      />
      <OptionsEditorControl
        label="Max value"
        description="Maximum data value mapped to the color palette"
        control={
          <TextField
            fullWidth
            type="number"
            value={value.max ?? ''}
            onChange={(e) => onChange({ ...value, max: e.target.value ? Number(e.target.value) : undefined })}
            placeholder="Default"
          />
        }
      />
      <OptionsEditorControl
        label="Hide zeros"
        control={
          <Switch
            checked={value.hideZeros ?? false}
            onChange={(e) => onChange({ ...value, hideZeros: e.target.checked })}
          />
        }
      />
    </OptionsEditorGroup>
  );
}
